import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const sections = [
  {
    number: 1,
    title: 'Ерөнхий нөхцөл',
    paragraphs: [
      'ARYA онлайн сургалтын платформ нь хэрэглэгчдэд чанартай боловсролын контент, видео хичээл, интерактив сургалтуудыг цахим орчинд хүргэх зорилготой үйлчилгээ юм.',
      'Энэхүү үйлчилгээний нөхцөл нь ARYA платформд бүртгүүлж, сургалтад хамрагдаж буй бүх суралцагч болон багш нарт хамаарна. Платформыг ашигласнаар та эдгээр нөхцөлийг бүрэн зөвшөөрсөнд тооцогдоно.',
      'Манай сургалтын контент, видео хичээл, материалуудыг ARYA-ийн бичгэн зөвшөөрөлгүйгээр хуулбарлах, тарааж түгээх, худалдах, гуравдагч этгээдэд дамжуулахыг хатуу хориглоно.',
    ],
  },
  {
    number: 2,
    title: 'Бүртгэл ба хандалт',
    paragraphs: [
      'Суралцагч нь платформд бүртгүүлэхдээ үнэн зөв мэдээлэл оруулах үүрэгтэй. Нэг хүн зөвхөн нэг бүртгэлтэй байна.',
      'Бүртгэлийн нэвтрэх мэдээлэл (имэйл, нууц үг)-ээ найдвартай хадгалах нь хэрэглэгчийн хариуцлага юм. Бүртгэлийн мэдээлэл алдагдсанаас үүсэх аливаа хохирлыг хэрэглэгч өөрөө хариуцна.',
      'Платформын дүрэм зөрчсөн хэрэглэгчийн бүртгэлийг урьдчилан мэдэгдэлгүйгээр түр түдгэлзүүлэх буюу бүрмөсөн устгах эрхтэй.',
    ],
  },
  {
    number: 3,
    title: 'Сургалтын захиалга ба төлбөр',
    paragraphs: [
      'Сургалт худалдан авсны дараа тухайн сургалтын контентод хугацаагүй хандах эрхтэй болно. Хугацаатай эсвэл Premium гишүүнчлэлийн сургалтын хувьд тусгай нөхцөл хамаарна.'
    ],
  },
  {
    number: 4,
    title: 'Суралцагчийн үүрэг',
    paragraphs: [
      'Суралцагч нь сургалтын материалыг зөвхөн хувийн суралцах зорилгоор ашиглах ёстой. Бусдад дамжуулах, нийтэд нээлттэй болгох, арилжааны зорилгоор ашиглахыг хориглоно.',
      'Платформ дээр хууль бус, зохисгүй контент нийтлэх, бусад суралцагч болон багш нарын эрхийг зөрчих үйлдэл хийхийг хориглоно.',
      'Сургалтын явцад бусдын оюуны өмчийг зөвшөөрөлгүй ашиглах, хуулж авах нь нөхцөл зөрчилд тооцогдоно.',
    ],
  },
  {
    number: 5,
    title: 'Багшийн үүрэг ба эрх',
    paragraphs: [
      'Багш нар нь зөвхөн өөрийн бүтээсэн эсвэл зохиогчийн эрх эзэмшиж буй контентыг платформд байршуулах үүрэгтэй.',
      'Багш нар сургалтын чанарыг тогтмол сайжруулах, суралцагчдын асуулт, санал хүсэлтэд хариу өгөх үүрэгтэй.',
      'ARYA нь сургалтын контентын чанарт хяналт тавих, шаардлага хангаагүй контентыг устгах эрхтэй.',
    ],
  },
  {
    number: 6,
    title: 'Оюуны өмч',
    paragraphs: [
      'ARYA платформ дээрх бүх сургалтын контент, видео хичээл, материал, дизайн нь ARYA болон тухайн багш нарын оюуны өмч юм.',
      'Суралцагч нь сургалтын явцад бүтээсэн өөрийн даалгавар, төслийн оюуны өмчийн эрхээ бүрэн эзэмшинэ.',
    ],
  },
]

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4">
        <div className="max-w-[1024px] mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 text-sm font-medium text-gray-800 bg-white border border-gray-200 rounded-full px-4 py-2.5 shadow-md hover:bg-gray-50 transition"
          >
            <ArrowLeft className="size-5" />
            Буцах
          </Link>
        </div>
      </div>

      {/* Title */}
      <div className="text-center pt-8 pb-6">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800">ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h1>
        <p className="text-base text-gray-500 mt-3 max-w-[500px] mx-auto">
          ARYA онлайн сургалтын платформыг ашиглахын өмнө дараах нөхцөлүүдтэй танилцана уу.
        </p>
      </div>

      {/* Content */}
      <div className="max-w-[1024px] mx-auto px-4 pb-20">
        <div className="flex flex-col gap-8">
          {sections.map((section) => (
            <div key={section.number} className="flex flex-col gap-6">
              <div className="flex flex-col gap-6 items-end">
                <h2 className="w-full text-2xl font-medium text-gray-800">
                  <ol start={section.number} className="list-decimal pl-9">
                    <li>{section.title}</li>
                  </ol>
                </h2>
                <hr className="border-gray-200 w-full" />
                <div className="flex flex-col gap-4 w-full">
                  {section.paragraphs.map((paragraph, index) => (
                    <p key={index} className="text-lg text-gray-600 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
